import { useState } from "react";
import { createContext } from "react";

export const AppContext = createContext();

const AppContextProvider = (props) => {
  localStorage.setItem(
    "isLight",
    localStorage.getItem("isLight") ? localStorage.getItem("isLight") : true
  );
  localStorage.setItem(
    "current",
    localStorage.getItem("current")
      ? localStorage.getItem("current")
      : "default"
  );
  const [isLight, setTheme] = useState(
    localStorage.getItem("isLight") === "true"
  );
  const [current, setCurrent] = useState(localStorage.getItem("current"));
  const [currentTheme, setCurrentTheme] = useState({
    default: {
      bg: "#edfffa",
      dark_bg: "#252826",
      text: "#252826",
      dark_text: "#edfffa",
      font: "cursive",
      tertiary_color: "#08201e",
      dropdown: "#ffffff",
      dark_dropdown: "#181a19",
    },
    commerce: {
      bg: "#b8cfff",
      dark_bg: "#000035",
      text: "#000035",
      dark_text: "#b8cfff",
      tertiary_color: "#000060",
      font: "Verdana",
      dropdown: "#dde8ff",
      dark_dropdown: "#000022",
    },
    financial: {
      bg: "#deffc3",
      dark_bg: "#182218",
      text: "#182218",
      dark_text: "#deffc3",
      tertiary_color: "#072407",
      font: "Lucida Sans Unicode",
      dropdown: "#ebffda",
      dark_dropdown: "#0b120b",
    },
    business: {
      bg: "#f0ccff",
      dark_bg: "#26172c",
      text: "#26172c",
      dark_text: "#e6aaff",
      tertiary_color: "#1d0627",
      font: "monospace",
      dropdown: "#f6e1ff",
      dark_dropdown: "#1b1020",
    },
    volunteer: {
      bg: "#ffafbb",
      dark_bg: "#310606",
      text: "#310606",
      dark_text: "#f8c5c5",
      tertiary_color: "#400101",
      font: "monospace",
      dropdown: "#ffd4db",
      dark_dropdown: "#290404",
    },
  });
  return (
    <AppContext.Provider
      value={{
        currentTheme,
        setCurrentTheme,
        current,
        setCurrent,
        isLight,
        setTheme,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
